import { gql } from '@apollo/client'

export const SendVerification = gql`
    mutation SendVerification($email: String!) {
        sendVerification(email: $email)
    }
`

export default SendVerification
